// First validation message of an SFetch JSON error whose body is shaped
// `{ errors: { attribute: [messages] } }`, the way Rails controllers render
// model errors. Null for any other error, so callers fall back to their own
// generic message.
export function extractServerErrorMessage(error: unknown): string | null {
  if (typeof error !== 'object' || error === null) return null
  const maybe = error as {
    body?: { errors?: Record<string, string[] | undefined> }
  }
  const errors = maybe.body?.errors
  if (!errors) return null
  for (const key of Object.keys(errors)) {
    const messages = errors[key]
    if (messages && messages.length > 0) return messages[0]
  }
  return null
}
